import PropTypes from "prop-types";
import NextbtnImg from "assets/arrowBtn.svg";
import "../styles.css";

function HolesFooter({
  onPrevHole,
  holeIndex,
  onNextHole,
  onSubmitMatchDisabled,
  onSubmitMatch,
  isBlockedSubmit,
}) {
  return (
    <div className="holes--footer">
      <button
        type="button"
        className="btn-directions"
        onClick={onPrevHole}
        disabled={holeIndex === 0}
      >
        <img className="prev-btn" src={NextbtnImg} alt="prev" />
      </button>

      <button
        onClick={onSubmitMatch}
        type="button"
        disabled={!onSubmitMatchDisabled || isBlockedSubmit}
        aria-hidden="true"
        className={`scorecard-footer--submitButton ${
          (!onSubmitMatchDisabled || isBlockedSubmit) &&
          "scorecard-footer--submitButton-disabled"
        }`}
      >
        {onSubmitMatchDisabled ? "Submit Team Score" : "Submit score"}
      </button>

      <button type="button" className="btn-directions" onClick={onNextHole}>
        <img src={NextbtnImg} alt="next" />
      </button>
    </div>
  );
}

HolesFooter.propTypes = {
  holeIndex: PropTypes.number,
  onSubmitMatchDisabled: PropTypes.bool.isRequired,
  onNextHole: PropTypes.func.isRequired,
  onPrevHole: PropTypes.func.isRequired,
  onSubmitMatch: PropTypes.func.isRequired,
  isBlockedSubmit: PropTypes.bool.isRequired,
};

HolesFooter.defaultProps = {
  holeIndex: null,
};

export { HolesFooter };
